export default {
  methods: {
    nth (n) {
      switch (n) {
        case 0:
          return '1st'
        case 1:
          return '2nd'
        case 2:
          return '3rd'
        default:
          return `${n + 1}th`
      }
    }
  }
}
